<div class="task-list-entry" *ngIf="!clientStatusService.isMobile">
  <sc-selectable-tile [style]="selected ? 'selected' : 'default'">
    <sc-padding>
      <sc-flex>
        <div class="icon">
          <sc-icon iconClass="fa-shield-check" *ngIf="task.type === taskType.CHECK" large></sc-icon>
          <sc-icon iconClass="fa-file" *ngIf="task.type === taskType.DOCUMENT" large></sc-icon>
          <sc-icon iconClass="fa-camera" *ngIf="task.type === taskType.PICTURE" large></sc-icon>
        </div>
        <sc-content-spacer></sc-content-spacer>
        <sc-text-label labelDictionaryKey="tmc-yard.ui.task-assignment-dialog.name" [labelDictionaryKey]="task.nameDictionaryKey"
          class="name-field"></sc-text-label>
        <sc-content-spacer></sc-content-spacer>
        <sc-text-label labelDictionaryKey="tmc-yard.ui.task-assignment-dialog.relevance"
          labelDictionaryKey="tmc-yard.ui.task-assignment-dialog.relevance.{{task.relevance}}"></sc-text-label>
        <sc-content-spacer grow></sc-content-spacer>
        <div class="status">
          <sc-icon iconClass="fa-check" *ngIf="task.done" large></sc-icon>
          <sc-icon iconClass="fa-exclamation-triangle important" *ngIf="task.important && !task.done" large></sc-icon>
        </div>
      </sc-flex>
    </sc-padding>
  </sc-selectable-tile>
</div>
<div class="task-list-entry-mobile" *ngIf="clientStatusService.isMobile">
  <sc-selectable-tile [style]="selected ? 'selected' : 'default'">
    <sc-padding>
      <sc-flex>
        <div class="icon">
          <sc-icon iconClass="fa-shield-check" *ngIf="task.type === taskType.CHECK"></sc-icon>
          <sc-icon iconClass="fa-file" *ngIf="task.type === taskType.DOCUMENT"></sc-icon>
          <sc-icon iconClass="fa-camera" *ngIf="task.type === taskType.PICTURE"></sc-icon>
        </div>
        <sc-content-spacer></sc-content-spacer>
        <div>
          <div><sc-dictionary-label [dictionaryKey]="task.nameDictionaryKey"></sc-dictionary-label></div>
          <div class="relevance"><sc-dictionary-label
              [dictionaryKey]="'tmc-yard.ui.task-assignment-dialog.relevance.' + task.relevance"></sc-dictionary-label>
          </div>
        </div>
        <sc-content-spacer grow></sc-content-spacer>
        <div class="status">
          <sc-icon iconClass="far fa-check" *ngIf="task.done"></sc-icon>
          <sc-icon iconClass="far fa-exclamation-triangle important" *ngIf="task.important && !task.done"></sc-icon>
        </div>
      </sc-flex>
    </sc-padding>
  </sc-selectable-tile>
</div>
